import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import * as Mui from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";

export default function Breadcrumbs() {
  const navigate = useNavigate();
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  return (
    <Mui.Breadcrumbs aria-label="breadcrumb" color="primary.contrastText">
      <Mui.Link
        onClick={() => navigate("/")}
        sx={{ display: "flex", alignItems: "center", cursor: "pointer", color: "inherit" }}
      >
        <HomeIcon sx={{ mr: 0.5 }} color="inherit" fontSize="inherit" />
        Home
      </Mui.Link>
      {pathnames.map((value, index) => {
        const isLast = index === pathnames.length - 1;
        const to = "/" + pathnames.slice(0, index + 1).join("/");

        return isLast ? (
          <Mui.Typography color="inherit" key={to}>
            {decodeURIComponent(value)}
          </Mui.Typography>
        ) : (
          <Mui.Link
            color="inherit"
            onClick={() => navigate(to)}
            key={to}
            sx={{ cursor: "pointer" }}
          >
            {decodeURIComponent(value)}
          </Mui.Link>
        );
      })}
    </Mui.Breadcrumbs>
  );
}